// Test IDs for the BulkUsedTires.com landing page & bulk order form.

export const NAV = {
  logo: 'nav-logo',
  linkQuality: 'nav-link-quality',
  linkOrder: 'nav-link-order',
  linkServices: 'nav-link-services',
  linkFaq: 'nav-link-faq',
  linkBlog: 'nav-link-blog',
  linkContact: 'nav-link-contact',
  linkWholesaleQuote: 'nav-link-wholesale-quote',
  linkExportHub: 'nav-link-export-hub',
  ctaOrder: 'nav-cta-order',
  mobileMenuToggle: 'nav-mobile-menu-toggle',
  mobileMenuPanel: 'nav-mobile-menu-panel',
};

export const HERO = {
  section: 'hero-section',
  ctaPrimary: 'hero-cta-build-order',
  ctaSecondary: 'hero-cta-view-quality',
  statusPill: 'hero-status-pill',
};

export const MARQUEE = {
  ticker: 'marquee-ticker',
};

export const VIDEO_SHOWCASE = {
  section: 'video-showcase-section',
  player: 'video-showcase-player',
  muteToggle: 'video-showcase-mute-toggle',
  cta: 'video-showcase-cta',
};

export const QUALITY = {
  section: 'quality-tiers-section',
  cardGradeA: 'quality-card-grade-a',
  cardGradeB: 'quality-card-grade-b',
  cardGradeC: 'quality-card-grade-c',
};

export const SERVICES = {
  section: 'services-section',
  cardSorting: 'services-card-sorting',
  cardTripling: 'services-card-tripling',
  cardFreight: 'services-card-freight',
};

export const TESTIMONIALS = {
  section: 'testimonials-section',
};

export const ORDER = {
  section: 'order-form-section',
  tierButton: (qty) => `order-tier-${qty}`,
  nameInput: 'order-input-name',
  emailInput: 'order-input-email',
  phoneInput: 'order-input-phone',
  businessInput: 'order-input-business',
  requestInput: 'order-input-request',
  cityInput: 'order-input-city',
  stateInput: 'order-input-state',
  countryInput: 'order-input-country',
  continueButton: 'order-continue-button',
  accountPasswordInput: 'order-account-password-input',
  accountSubmitButton: 'order-account-submit-button',
  submitOnlineButton: 'order-submit-online-button',
  downloadButton: 'order-download-button',
  resetButton: 'order-reset-button',
  successMessage: 'order-success-message',
  sizeChip: (size) => `order-size-chip-${size.replace(/[^a-zA-Z0-9]/g, '')}`,
  sizesConfirmButton: 'order-sizes-confirm-button',
  sizesSkipButton: 'order-sizes-skip-button',
  sizesSelectedCount: 'order-sizes-selected-count',
};

export const WHATWEDO = {
  section: 'what-we-do-section',
  cardExport: 'whatwedo-card-export',
  cardDomestic: 'whatwedo-card-domestic',
};

export const INTL = {
  section: 'international-section',
  ctaConsult: 'intl-cta-consult',
  containerNote: 'intl-container-note',
  ctaWholesaleQuote: 'intl-cta-wholesale-quote',
};

export const NEWTIRES = {
  section: 'new-tires-section',
  ctaInquire: 'new-tires-cta-inquire',
};

export const EXPORT_CTA = {
  section: 'export-cta-section',
  ctaButton: 'export-cta-view-hub-button',
};

export const CONTACT = {
  section: 'contact-section',
  address: 'contact-address',
  email: 'contact-email',
  phone: 'contact-phone',
  ctaEmail: 'contact-cta-email',
  ctaBookMeeting: 'contact-cta-book-meeting',
};

export const FOOTER = {
  section: 'footer-section',
};

export const EXPORT_PAGE = {
  section: 'export-page-section',
  faqItem: (i) => `export-page-faq-item-${i}`,
  draftBanner: 'export-page-draft-banner',
  complianceSection: 'export-page-compliance-section',
  ctaButton: 'export-page-cta-button',
};

export const EXPORT_HUB_PAGE = {
  section: 'export-hub-page-section',
  searchInput: 'export-hub-search-input',
  countryCard: (slug) => `export-hub-country-card-${slug}`,
  noResults: 'export-hub-no-results',
};
